<template>
  <router-link
    :to="to"
    class="list-group-item list-group-item-action row-notification"
    :class="{
      noread: read === false
    }"
  >
    <div class="row align-items-center content">
      <div class="col-auto icon-notify" :class="statusColor(type)">
        <i :class="getIcon(type)"></i>
      </div>
      <div class="col pl-0">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h4 class="title">
              {{ title }}
            </h4>
          </div>
          <div class="time">
            <span>{{ datetime }}</span>
          </div>
        </div>
        <p class="descrip">
          {{ message }}
        </p>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "base-notifications",
  props: {
    to: {
      type: String,
      default: "#",
      description: "route of the notification"
    },
    type: {
      type: String,
      default: "default",
      description: "Type notification: new, updated,delete"
    },
    title: {
      type: String,
      description: "title of the notification"
    },
    message: {
      type: String,
      description: "Message of the notification"
    },
    datetime: {
      type: String,
      description: "time of the notification"
    },
    read: {
      type: Boolean,
      description: "read or not"
    }
  },
  data() {
    return {};
  },
  methods: {
    statusColor: function(status) {
      if (status === "success") {
        return "text-green";
      } else if (status === "danger" || status === "removed") {
        return "text-red";
      } else if (status === "warning" || status === "updated") {
        return "text-warning";
      } else if (status === "null") {
        return "text-dark";
      } else if (status === "created") {
        return "text-new";
      }
    },
    getIcon(status) {
      if (status === "warning" || status === "updated") {
        return "flaticon-pencil";
      } else if (status === "created") {
        return "flaticon-add";
      } else if (status === "success") {
        return "flaticon-bold-check-3";
      } else if (status === "danger" || status === "removed") {
        return "flaticon-remove";
      } else if (status === "null") {
        return "flaticon-no-group";
      } else {
        return "flaticon-rec";
      }
    }
  },
  filters: {}
};
</script>
